import { Typography } from "@mui/material";
import ClientIcon from "../../assets/icons/Clients_Flow_Icons/childHeaderIcons/ClientIcon";
import PercentageIcon from "../../assets/icons/Clients_Flow_Icons/childHeaderIcons/PercentageIcon";
import Tooltip from "../../components/ui/Tooltip";

const ClientsChildHeader = ({ sectionCounts = {} }) => {
  const data = [
    {
      value: sectionCounts["WIP"] || 0,
      tooltip: "WIP",
      color: "#51A47A",
      backgroundColor: "#51A47A1F",
      percentage: 7,
      trend: "up",
    },
    {
      value: sectionCounts["Quotes & Order"] || 0,
      tooltip: "Quote & Order",
      color: "#C7B34E",
      backgroundColor: "#C7B34E1F",
      percentage: 5,
      trend: "up",
    },
    {
      value: sectionCounts["Dues"] || 0,
      tooltip: "Dues",
      color: "#B98D35",
      backgroundColor: "#B98D351F",
      percentage: 3,
      trend: "down",
    },
    {
      value: sectionCounts["Not Active"] || 0,
      tooltip: "Not Active",
      color: "#B16A63",
      backgroundColor: "#B16A631F",
      percentage: 1,
      trend: "up",
    },
    {
      value: sectionCounts["Dead Since 1 year"] || 0,
      tooltip: "Dead since 1 year",
      color: "#7F7F7F",
      backgroundColor: "#7F7F7F1F",
      percentage: 2,
      trend: "down",
    },
  ];

  const renderTrendArrow = (trend) => {
    return <PercentageIcon flow={trend} />;
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", backgroundColor: "#0D0D0D", padding: "0px 16px", borderRadius: "4px", height: "40px" }}>
      <Typography
        sx={{
          color: "#FCFAFA",
          fontFamily: "Karla",
          fontWeight: "500",
          fontSize: "15px",
          lineHeight: "20px",
          letterSpacing: "0px",
        }}
      >
        Clients :
      </Typography>
      {data.map((item, index) => (
        <Tooltip key={index} title={item.tooltip} arrow>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "4px 8px",
              borderRadius: "4px",
              fontFamily: "Karla",
              fontWeight: "500",
              fontSize: "16px",
              lineHeight: "18px",
              gap: "5px",
              cursor: "pointer",
              minWidth: "60px",
              justifyContent: "center",
            }}
          >
            <ClientIcon color={item.color} backgroundColor={item.backgroundColor} />
            <span style={{ color: "#FFFFFF" }}>{item.value}</span>
            <span
              style={{
                fontSize: "10px",
                color: item.trend === "up" ? "#51A47A" : "#B16A63",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                lineHeight: "1",
              }}
            >
              <span>{renderTrendArrow(item.trend)}</span>
              <span>{item.percentage}%</span>
            </span>
          </div>
        </Tooltip>
      ))}
    </div>
  );
};

export default ClientsChildHeader;
